module.exports = __webpack_public_path__ + "static/media/58.f2973f18.png";